import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ProjectInforApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'projectinfor'
    }


    /**
     * 查询项目分页列表
     * @returns 
     */
    public getEntitiesPage(params){
        return this.send(params,"getEntitiesPage",Methods.GET)
    }

    /**
     * 系统项目保存
     * @param params
     */
    public saveObj(params){
        return this.send(params,"saveObj",Methods.POST)
    }

    /**
     * 查询项目列表
     * @returns
     */
       public getProjectList(projectName){
        return this.send({projectName:projectName},"getProjectList",Methods.GET)
    }


    public updateDelFlag(id){
        return this.send({},"updateDelFlag?id="+id,Methods.POST)
    }

   
}